import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from '@material-ui/core';

const LocationDialog = ({
  openLocationsDialog,
  setOpenLocationsDialog,
  branches = [],
  rows,
  setRows,
}) => {
  const { t } = useTranslation();

  const agregarNuevoCampo = () => {
    const nuevoId = rows.length + 1;
    setRows([...rows, { id: nuevoId, email: '', location: '' }]);
  };

  const manejarCambio = (id, field, value) => {
    setRows(rows.map((row) => (row.id === id ? { ...row, [field]: value } : row)));
  };

  const eliminarCampo = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleClose = () => {
    setOpenLocationsDialog(false);
  };

  return (
    <Dialog open={openLocationsDialog} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>{t('task.email.locationsDialog.title')}</DialogTitle>
      <DialogContent>
        {rows.map((row) => (
          <Grid container spacing={2} alignItems="center" key={row.id} style={{ marginBottom: '10px' }}>
            <Grid item xs={5}>
              <TextField
                label={t('task.email.emails')}
                type="email"
                variant="outlined"
                size="small"
                fullWidth
                value={row.email}
                onChange={(e) => manejarCambio(row.id, 'email', e.target.value)}
              />
            </Grid>
            <Grid item xs={5}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>Sucursal</InputLabel>
                <Select
                  value={row.location}
                  onChange={(e) => manejarCambio(row.id, 'location', e.target.value)}
                  label="Sucursal"
                >
                  {branches.map((branch) => (
                    <MenuItem key={branch.id} value={branch.id}>
                      {branch.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="warning"
                onClick={() => eliminarCampo(row.id)}
              >
                ✕
              </Button>
            </Grid>
          </Grid>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={agregarNuevoCampo} color="primary" variant="outlined">
          {t('task.email.locationsDialog.add')}
        </Button>
        <Button onClick={handleClose} color="primary">
          {t('task.email.locationsDialog.cancel')}
        </Button>
        <Button onClick={handleClose} color="primary" variant="contained">
          {t('task.email.locationsDialog.ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocationDialog;
